<template>
  <div class="row">
    <div class="col-md-12">
      <b-collapse
        id="filtroTablesSve"
        class="filtros p-4 position-relative"
        accordion="my-accordion"
        role="tabpanel"
      >
        <div>
          <div class="row col-12 mx-0 px-0">
            <div class="col-md-4">
              <Typography
                text="General"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2 space-y-4">
                <Select
                  label="Tipo de SVE"
                  name="type_sve"
                  :options="optionsSVE"
                  :value="valuesFilter.type_sve"
                  v-model="valuesFilter.type_sve"
                />
                <Select
                  label="Caracterización del GES"
                  name="characterization"
                  :options="options_C"
                  :value="valuesFilter.characterization"
                  v-model="valuesFilter.characterization"
                />
                <div class="">
                  <Input
                    label="Nombre del GES"
                    name="q"
                    :value="valuesFilter.q"
                    @input="
                      (event) => (valuesFilter.q = event.target.value)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <Typography
                text="Colaborador"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2">
                <div class="">
                  <Input
                    label="Nombre empleado o cédula"
                    name="employee"
                    :value="valuesFilter.employee"
                    @input="
                      (event) =>
                        (valuesFilter.employee = event.target.value)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <Typography
                text="Rango de Fecha"
                variant="CTA"
                color="#5d5fef"
                class="border-filters-title"
              />
              <div class="pt-2 space-y-4">
                <Date
                  name="start_date"
                  label="Inicio"
                  v-model="valuesFilter.start_date"
                  :value="valuesFilter.start_date"
                  :max="valuesFilter.end_date"
                />
                <Date
                  name="end_date"
                  label="Fin"
                  v-model="valuesFilter.end_date"
                  :value="valuesFilter.end_date"
                  :min="valuesFilter.start_date"
                />
              </div>
            </div>
            <div class="col-md-12 mb-5" v-if="isDisabled">
              <div class="d-flex justify-content-end">
                <Button
                  variant="primary"
                  small
                  pill
                  class="mr-2"
                  :disabled="loading"
                  @click.prevent="submitFilter"
                >
                  <span class="mr-2">Aplicar filtros</span>
                  <b-spinner v-if="loading" />
                </Button>
                <Button
                  variant="danger"
                  small
                  pill
                  label="Limpiar filtros"
                  @click.prevent="clearFilter"
                  :disabled="loading || !isDisabled"
                />
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/general/Typography";
import Button from "@/components/general/Button";
import useInputs from "@/components/general/Inputs";
const { Input, Select, Date } = useInputs();
export default {
  components: {
    Typography,
    Input,
    Select,
    Date,
    Button,
  },
  props: {
    optionsSVE: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      valuesFilter: {
        type_sve: null,
        characterization: null,
        q: null,
        employee: null,
        start_date: "",
        end_date: "",
      },
      options_C: [
        { id: "", name: "Realizar riesgo potencial" },
        { id: "Riesgo bajo", name: "Riesgo bajo" },
        { id: "Riesgo medio", name: "Riesgo medio" },
        { id: "Riesgo alto", name: "Riesgo alto" },
        { id: "Por definir en IPT", name: "Por definir en IPT" },
      ],
    };
  },
  computed: {
    isDisabled() {
      const me = this;
      return Object.values(me.valuesFilter).some(
        (filter) => filter !== null && filter !== ""
      );
    },
  },
  methods: {
    clearFilter() {
      const me = this;
      me.valuesFilter = {
        type_sve: null,
        characterization: null,
        q: null,
        employee: null,
        start_date: "",
        end_date: "",
      }
      me.$emit("submitFilter", null);
    },
    submitFilter() {
      const me = this;
      const searchValue = {
        ...(me.valuesFilter.start_date && {start_date: me.valuesFilter.start_date }),
        ...(me.valuesFilter.end_date && {end_date: me.valuesFilter.end_date }),
        ...(me.valuesFilter.employee && {employee: me.valuesFilter.employee }),
        ...(me.valuesFilter.q && {q: me.valuesFilter.q }),
        ...(me.valuesFilter.type_sve && {type_sve: me.valuesFilter.type_sve.id }),
        ...(me.valuesFilter.characterization && {characterization: me.valuesFilter.characterization.id }),
      }
      me.$emit("submitFilter", searchValue);
    },
  }
};
</script>

<style lang="scss" scoped></style>
